/* eslint-disable max-lines */
import { ComponentStyleConfig, cssVar } from '@chakra-ui/react';

const $textDisabled = cssVar('chakra-colors-M-40');

const activeLabelStyles = {
  transform: 'scale(0.85) translateY(-10px)',
  fontSize: '10px',
  fontWeight: 500,
  left: 0,
  pt: 0,
  letterSpacing: '0.96px',
};

export const Form: ComponentStyleConfig = {
  variants: {
    floating: {
      container: {
        h: '70px',
        _focusWithin: {
          label: {
            ...activeLabelStyles,
          },
        },
        'input:-webkit-autofill ~ label': {
          ...activeLabelStyles,
        },
        'textarea:-webkit-autofill ~ label': {
          ...activeLabelStyles,
        },
        'input:not(:placeholder-shown) ~ label, .chakra-select__wrapper + label, .chakra-react-select--has-value + label': {
          ...activeLabelStyles,
        },
        '.chakra-react-select__option--is-selected': {
          color: 'textSubdued',
        },
        'textarea:not(:placeholder-shown) ~ label': {
          ...activeLabelStyles,
        },
        label: {
          color: 'textSubdued',
          fontSize: 'sm',
          fontWeight: 400,
          top: 0,
          left: 0,
          zIndex: 1,
          position: 'absolute',
          pointerEvents: 'none',
          userSelect: 'none',
          mx: 2,
          px: '5px',
          my: '13px',
          transformOrigin: 'left top',
          '&.hasPlaceholder': {
            ...activeLabelStyles,
          },
          '&.isDisabled': {
            color: 'M.60',
            opacity: 1,
          },
          _disabled: {
            color: 'M.60',
            opacity: 1,
          },
        },
        input: {
          borderRadius: 2,
          lineHeight: 1.4,
          letterSpacing: '0.5px',
          _autofill: {
            textFillColor: 'var(--chakra-colors-textBase)',
            caretColor: 'var(--chakra-colors-textBase)',
          },
          // Disables autofill background:
          '&:-webkit-autofill': {
            WebkitBoxShadow: '0 0 0px 1000px var(--chakra-colors-M-20) inset',
            backgroundClip: 'content-box',
            '&:hover, &:focus': {
              WebkitBoxShadow: '0 0 0px 1000px var(--chakra-colors-M-20) inset',
            },
          },
          color: 'textBase',
          borderColor: 'borderBase',
          bg: 'surface2',
          textOverflow: 'ellipsis',
          '&.hasLabel': {
            pt: 2,
          },
          '&:focus:not(:disabled)': {
            borderColor: 'borderBase',
            // TODO: Disable this after making designers agree with focus rings
            boxShadow: 'none',
          },
          '&[type="password"]': {
            color: 'textBase',
          },
          '::placeholder': {
            color: 'textPlaceholder',
          },
          _invalid: {
            boxShadow: 'none',
          },
          '&:hover:not(:disabled)': {
            borderColor: 'borderBase',
          },
          _disabled: {
            cursor: 'default',
            color: 'M.40',
            WebkitTextFillColor: $textDisabled.reference,
            opacity: 1,
            '::placeholder': {
              color: 'M.40',
            },
          },
          _focusVisible: {
            boxShadow: '0px 0px 8px 0px var(--chakra-colors-B-50)',
          },
        },
        textarea: {
          pt: 4,
          minHeight: '55px',
          bg: 'surface2',
          borderColor: 'borderBase',
          '::placeholder': {
            color: 'textPlaceholder',
          },
          _focus: {
            borderColor: 'borderBase',
            boxShadow: 'none',
          },
          _hover: {
            borderColor: 'borderBase',
          },
          _invalid: {
            boxShadow: 'none',
          },
          _focusVisible: {
            boxShadow: '0px 0px 8px 0px var(--chakra-colors-B-50)',
          },
        },
        ' .chakra-form__helper-text': {
          mx: 3,
          my: 1,
          fontSize: 'xxs',
          color: 'textSubdued',
        },
        ' .chakra-form__error-message': {
          color: 'R.80',
          m: 0,
          py: 1,
          px: 3,
        },
      },
    },
    switchControl: {
      container: {
        display: 'flex',
        alignItems: 'center',
        bg: 'surface2',
        border: '1px solid',
        borderColor: 'borderBase',
        _hover: {
          borderColor: 'borderBase',
        },
        _focus: {
          borderColor: 'borderBase',
          boxShadow: 'none',
        },
        _invalid: {
          boxShadow: 'none',
        },
        width: '100%',
        borderRadius: 8,
        height: '48px',
        px: 3,

        label: {
          fontSize: 'sm',
          fontWeight: 400,
          backgroundColor: 'transparent',
          marginBottom: 0,
          color: 'textSubdued',
          _disabled: {
            color: 'textSubdued',
            opacity: 1,
          },
        },
      },
    },
    unstyled: {
      container: {
        'input, textarea': {
          resize: 'none',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          border: 'none',
          padding: 0,
          borderRadius: 0,
          _focus: {
            border: 'none',
            shadow: 'none',
          },
          _invalid: {
            boxShadow: 'none',
          },
          '::placeholder': {
            color: 'textPlaceholder',
          },
        },
        ' .chakra-form__error-message': {
          position: 'absolute',
          bottom: '-4px',
        },
      },
    },
  },
};
